import ISpinData, {
    IOverlayData,
    ISpinificationData,
    IWinData,
} from "../../../core/src/server/data/ISpinData";
import AbstractBulkDataParser from "../../../core/src/server/parsers/AbstractBulkDataParser";
import GameModel from "../../../core/src/model/GameModel";
import Utils from "../../../core/src/utils/Utils";
import {
    IVendorSpinData,
    IVendorWinData,
    IVendorLineData,
    IVendorBonusData,
    IRoundData,
} from "../../model/IVendorSpinData";
import ConsoleUtil from "../../../core/src/utils/ConsoleUtil";
import JackpotsModel from "../../model/JackpotsModel";
import DebugModel from "../../../core/src/model/DebugModel";
import { BonusName } from "../data/BonusName";
import CommManager from "../../../core/src/controllers/CommManager";
import RoundType from "../../../core/src/const/RoundType";
export default class SpinDataParser extends AbstractBulkDataParser<ISpinData> {
    protected processedData: ISpinData[];
    protected accumulatedWin: number = 0;
    protected totalFreeSpinsCount = 0;
    protected currentFreeSpinsCount = 0;
        // respinLimit is to indicate the maximum amount of respins awarded to show, override in game specific
    //TODO when adding respinRetrigger make sure this is not used
    protected respinLimit = 0;

    protected validateData(data: IVendorSpinData): boolean {
        return !!data?.wager.data;
    }

    protected processData(data: IVendorSpinData): ISpinData[] | ISpinData {
        ConsoleUtil.warn("SPIN DATA", data);
        if (data) {
            if (DebugModel.fakeJackpot) {
                JackpotsModel.winAmount = DebugModel.fakeJackpot.amount;
                JackpotsModel.jackpotWonName = DebugModel.fakeJackpot.name;
                DebugModel.cleanUp();
            } else {
                // TODO: jackpot win
                // if (
                //     JackpotsModel.playForJackpot === true &&
                //     data.data.jackpot?.won
                // ) {
                //     JackpotsModel.winAmount = Number(
                //         data.data.jackpot.won.amount
                //     );
                //     JackpotsModel.jackpotWonName = data.data.jackpot.won.name;
                // }
            }

            this.accumulatedWin = 0;
            this.totalFreeSpinsCount = 0;
            this.currentFreeSpinsCount = 0;
        }

        // TODO: check restore
        // const spinData: IVendorSpinData =
        //     data.data.gameData ||
        //     data.data.lastSessionData.betResult.playData.gameData;
        const result: ISpinData = this.parseSlotObject(
            data.wager.data,
            undefined,
            undefined,
            undefined,
            RoundType.NORMAL
        );

        // Reset the main spin free spins counts.
        result.freespinsNum = 0;
        result.freespinsWon = 0;
        result.totalFreeSpins = 0;

        // Starting with the total free spins count, then we subtract the retriggers.
        // TODO:
        // let initialFreeSpinsCount = spinData.spinStats.freeSpinCount;
        // spinData?.bonusInfo?.forEach((bonusData) => {
        //     if (bonusData?.freeSpinList?.length) {
        //         bonusData.freeSpinList.forEach((spin) => {
        //             spin?.bonusInfo?.forEach((bonus) => {
        //                 if (
        //                     bonus.bonusName == BonusName.BonusFreeSpins &&
        //                     Utils.isNumeric(bonus.countFreeSpins)
        //                 ) {
        //                     initialFreeSpinsCount -= bonus.countFreeSpins;
        //                 }
        //             });
        //         });
        //     }
        // });

        let results: ISpinData[] = [];
        results.push(result);

        if (data.wager.data.freespins?.length) {
            // We have free spins awarded
            this.addRetriggerData(
                data.wager.data.freespins,
                result,
                results,
                data.wager.state.freeSpinsTotal
            );
        }

        if (data.wager.data.respin?.length) {
            // We have free spins awarded
            this.addRespinData(data.wager.data.respin, result, results, false);
        }

        // TODO: put this back! and figure out why it throws errors in FS
        // this.validateResults(results, data);

        return results;
    }

    protected validateResults(
        results: ISpinData[],
        spinData: IVendorSpinData
    ): void {
        // Computing the free spins win amounts and count.
        let freeWonAmount = 0;
        let freeWonCount = 0;
        results.forEach((res) => {
            if (res.isFree) {
                freeWonAmount += res.winAmount;
            }

            if (Utils.isNumeric(res.freespinsWon) && res.freespinsWon > 0) {
                freeWonCount += res.freespinsWon;
            }
        });

        // Define some number precision tolerance, needed for the comparisons
        const precision = 1e-4;

        // Check the free spins money
        if (
            !Utils.almostEquals(
                freeWonAmount,
                freeWonAmount, //spinData.spinStats.freeWon, // TODO: do we need this?
                precision
            )
        ) {
            // const errorMessage = `FATAL: Free spin wins are not computed properly! Expected: ${spinData.spinStats.freeWon}, Computed: ${freeWonAmount}`;
            // this.onError(spinData, errorMessage);
        }

        // Check the free spins (won) count, including the retriggered
        if (
            !Utils.almostEquals(
                freeWonCount,
                freeWonCount, // spinData.spinStats.freeSpinCount, // TODO: do we need this
                precision
            )
        ) {
            // const errorMessage = `FATAL: Free spin won count is not computed properly! Expected: ${spinData.spinStats.freeSpinCount}, Computed: ${freeWonCount}`;
            // this.onError(spinData, errorMessage);
        }

        // Ensure the accumulated wins are properly computed
        if (
            !Utils.almostEquals(
                this.accumulatedWin,
                spinData.wager.data.totalWin,
                precision
            )
        ) {
            const errorMessage = `FATAL: accumulatedWin differs the totalWon! Expected: ${spinData.wager.data.totalWin}, Computed: ${this.accumulatedWin}`;
            this.onError(spinData, errorMessage);
        } else {
            results.reduce((previous, current, index, array) => {
                if (
                    !Utils.almostEquals(
                        previous.accumulatedWin,
                        current.accumulatedWin - current.winAmount
                    )
                ) {
                    const errorMessage = `FATAL: accumulatedWin is not properly accumulated! Index: ${index}, Array: ${array}`;
                    this.onError(spinData, errorMessage);
                }

                return current;
            });
        }
    }

    protected getScatterWin(spinData: IRoundData) {
        const scatterWin = 0;
        // TODO: do we need this?
        // spinData?.bonusInfo?.find(
        //     (bonus) => bonus.bonusName == BonusName.Scatter
        // )?.creditsWon || 0;
        return scatterWin;
    }

    protected getRespinWin(spinData: IRoundData) {
        const respinWin = 0;
        // TODO: Get the correct value
        // spinData?.bonusInfo?.find(
        //     (bonus) => bonus.bonusName == BonusName.BonusReSpins
        // )?.creditsWon || 0;
        return respinWin;
    }

    protected onError(data: IVendorSpinData, errorMessage: string) {
        console.error(errorMessage, data);
        Utils.sendCustomError(errorMessage, data, CommManager.getComm());
        throw new Error(errorMessage);
    }

    /**
     * Pushes the freespins and retriggered freespins to the existing results.
     *
     * @private
     * @param {any[]} bonusData bonus data
     * @param {*} result The current result
     * @param {*} results Current results
     * @memberof SpinDataParser
     */
    protected addRetriggerData(
        bonusData: IRoundData[],
        result: ISpinData,
        results: ISpinData[],
        freeSpinCount: number
    ): void {
        if (!bonusData) {
            return;
        }

        if (!Utils.isNumeric(freeSpinCount)) {
            throw new Error("Non numeric freeSpinCount passed!");
        }

        if (freeSpinCount < 0) {
            throw new Error("Negative freeSpinCount passed!");
        }

        this.currentFreeSpinsCount += freeSpinCount;
        this.totalFreeSpinsCount += freeSpinCount;
        result.freespinsWon = freeSpinCount;

        if (bonusData.length == 0) {
            // This is a valid case for retrigger.
            // In such case the freeSpinCount param is passed,
            // so there is no actual need for the freeSpinList object.
            return;
        }

        if (this.currentFreeSpinsCount < 0 || this.totalFreeSpinsCount < 0) {
            throw new Error("Negative Free Spins counter detected (place 1)!");
        }

        result.freespinsNum = this.currentFreeSpinsCount;
        result.totalFreeSpins = this.totalFreeSpinsCount;

        const addFreeSpinData = (fsData: IRoundData) => {
            let fSpin = this.parseSlotObject(
                fsData,
                true,
                result.winAmount,
                Utils.deepClone(results),
                RoundType.FREE_SPIN
            );

            this.currentFreeSpinsCount--;
            fSpin.freespinsWon = 0;
            fSpin.freespinsNum = this.currentFreeSpinsCount;
            fSpin.totalFreeSpins = this.totalFreeSpinsCount;

            if (
                this.currentFreeSpinsCount < 0 ||
                this.totalFreeSpinsCount < 0
            ) {
                throw new Error(
                    "Negative Free Spins counter detected (place 2)!"
                );
            }

            results.push(fSpin);
            // Adding the respins, nested in a freespins list.
            if (fsData.respin?.length) {
                // We have free spins awarded
                this.addRespinData(fsData.respin, result, results, true);
            }
        };

        bonusData.forEach((fsData) => {
            if (Array.isArray(fsData)) {
                fsData.forEach((data) => {
                    addFreeSpinData(data);
                });
            } else {
                addFreeSpinData(fsData);
            }
        });
    }

    /**
     * Pushes the respins to the existing results.
     *
     * @private
     * @param {any[]} respins Array of bonus data
     * @param {*} result The current result
     * @param {*} results Current results
     * @memberof SpinDataParser
     */
    protected addRespinData(
        respins: IRoundData[],
        result: ISpinData,
        results: ISpinData[],
        isSpinFree: boolean
    ): void {
        if (respins.length) {
            result.reSpinData = {
                awarded: this.respinLimit,
                remaining: this.respinLimit,
                win:
                    respins.reduce((a, b) => {
                        return a + b.win;
                    }, 0) || 0,
                reTriggered: 0,
                reSpinsList: respins,
            };

            respins.forEach((rsData, index) => {
                let reSpin = this.parseSlotObject(
                    rsData,
                    isSpinFree,
                    result.winAmount,
                    Utils.deepClone(results),
                    RoundType.RE_SPIN
                );

                let remaining = rsData?.remaining;

                reSpin.reSpinData = {
                    awarded: this.respinLimit,
                    remaining: remaining,
                    win: rsData.win || 0,
                    reTriggered: 0,
                    reSpinsList: respins,
                };

                if (
                    reSpin.reSpinData.awarded < 0 ||
                    reSpin.reSpinData.remaining < 0
                ) {
                    throw new Error("Negative respin counter detected!");
                }

                results.push(reSpin);
                // Adding the respins, when in respin mode.

                // TODO: retrigger
                // if (rsData?.bonusInfo?.length) {
                //     rsData?.bonusInfo.forEach((bonusData) => {
                //         this.addRespinData(
                //             [bonusData],
                //             result,
                //             results,
                //             isSpinFree
                //         );
                //     });
                // }
            });
        }
    }

    parseSpinification(result: ISpinData): ISpinificationData {
        let spinification: ISpinificationData = {
            spinificationIndex: result.reelFinalSymbols.get(result.reelSetIndex)
                .length,
            spinificationEndIndex: result.reelFinalSymbols.get(
                result.reelSetIndex
            ).length,
        };
        let spinifyCount = new Map<number, number>();

        result.reelFinalSymbols.forEach((syms, reelSetIdx) => {
            syms.forEach((reel, reelId) => {
                reel.forEach((sym, rowId) => {
                    if (
                        GameModel.gameConfig.spinifySymIds?.indexOf(sym) != -1
                    ) {
                        if (!spinifyCount.has(sym)) {
                            spinifyCount.set(sym, 0);
                        }
                        spinifyCount.set(sym, spinifyCount.get(sym) + 1);
                        if (
                            spinifyCount.get(sym) ===
                                GameModel.gameConfig.spinifyNumSymsNeeded[
                                    sym
                                ] &&
                            GameModel.gameConfig.spinifyReels.indexOf(
                                reelId + 1
                            ) != -1
                        ) {
                            if (
                                !spinification.spinificationIndex ||
                                spinification.spinificationIndex > reelId + 1
                            ) {
                                spinification.spinificationIndex = reelId + 1;
                                spinification.spinificationSymbolId = sym;
                                spinification.spinificationEndIndex =
                                    GameModel.gameConfig.spinifyReels[
                                        GameModel.gameConfig.spinifyReels
                                            .length - 1
                                    ];
                            }
                        }
                    }
                });
            });
        });

        return spinification;
    }

    parseLine(winData: IVendorWinData): IWinData {
        // @ts-ignore
        let win: IWinData = {
            winSymbols: Array.from(
                new Array(winData.positions.length),
                (e, i) => {
                    return winData.positions[i].y;
                }
            ),
            winReels: Array.from(
                new Array(winData.positions.length),
                (e, i) => {
                    return winData.positions[i].x;
                }
            ),
            winSymId: GameModel.gameConfig.symbolResponseMap[winData.symbol].id,
            isWay: !(
                GameModel.serverGameConfig?.paylines &&
                GameModel.serverGameConfig.paylines.length > 0
            ), //TODO
            lineId: winData.lineIndex,
            normalLineWin: !!winData.lineIndex,
            creditsWon: winData.win,
        };

        win.coordinates = winData.positions.map((pos, index) => {
            return { x: win.winReels[index] + 1, y: win.winSymbols[index] + 1 };
        });

        return win;
    }

    parseWins(
        winData: IVendorWinData[],
        bonusInfo: IVendorBonusData[]
    ): IWinData[] {
        let wins: IWinData[] = [];
        if (winData?.length) {
            winData.forEach((win) => {
                wins.push(this.parseLine(win));
            });
        }
        // TODO: do we need this?
        // if (bonusInfo?.length) {
        //     bonusInfo.forEach((bonus) => {
        //         if (bonus.matchPositions?.length) {
        //             wins.push(this.parseLine(bonus));
        //         }
        //     });
        // }
        return wins;
    }

    parseSlotObject(
        spinData: IRoundData,
        isFree = false,
        mainSpinWin = 0,
        previousSpins?: ISpinData[],
        roundType?: RoundType | string
    ): ISpinData {
        let winsData = this.parseWins(
            spinData.winnings,
            [] // TODO: check this => spinData.bonusInfo
        );

        const scatterWin = this.getScatterWin(spinData);
        const respinWin = this.getRespinWin(spinData);

        const winAmount = !isFree
            ? // TODO: free spins => ? spinData.wager.win - spinData.freeGameCreditsWon - respinWin
              spinData.win - respinWin
            : spinData.win - respinWin;
        const reelSetIndex: number = this.parseReelSetIndex(spinData, isFree, mainSpinWin, previousSpins, roundType);
        const stopPositions = new Map<number, number[]>();
        const reelFinalSymbols = new Map<number, number[][]>();
        const reelStopSymbols = new Map<number, number[][]>();

        const numericSymbols = spinData.symbols.map((reel) =>
            reel.map(
                (symbol) => GameModel.gameConfig.symbolResponseMap[symbol].id
            )
        );
        GameModel.gameConfig.defaultSymbols = numericSymbols;
        stopPositions.set(reelSetIndex, spinData.stops);
        reelStopSymbols.set(reelSetIndex, numericSymbols.concat()); // TODO:
        reelFinalSymbols.set(reelSetIndex, numericSymbols.concat());

        let result: ISpinData = {
            winAmount,
            stopPositions,
            reelFinalSymbols,
            reelStopSymbols,
            winsData,
            reelSets: Utils.deepClone(GameModel.gameConfig.reelSets),
            reelSetIndex,
            isFree,
            roundType,
        };

        this.accumulatedWin += winAmount;
        result.accumulatedWin = this.accumulatedWin;
        result.skatterWin = scatterWin;

        let spinification = this.parseSpinification(result);
        let overlays: IOverlayData[] = this.parseOverlays(
            result,
            spinData,
            previousSpins
        );

        return Object.assign({}, result, {
            spinification,
            overlays,
        });
    }
    parseReelSetIndex = (
        spinData: IRoundData,
        isFree = false,
        mainSpinWin = 0,
        previousSpins?: ISpinData[],
        roundType?: RoundType | string
    ): number => {
        let result = isFree ? 1 : 0;
        return result
    }

    parseOverlays(
        result: ISpinData,
        spinData: IRoundData,
        previousSpins?: ISpinData[]
    ): IOverlayData[] {
        return null;
    }
}
